import React from 'react';
import { Tab } from 'src/components/sticky-tab-nav/types';
import { ProductPageQuery } from 'src/types';

import {
  ProductNavigationMainLink,
  ProductNavigationPropertiesLink,
  ProductNavigationReviewsLink,
  ProductNavigationHistoryLink,
} from './links/product-section-navigation-links';

export const getLinks = (
  product: ProductPageQuery['product'],
  selectedCondition: string | null
): Tab[] => {
  return [
    {
      id: '#main',
      title: (
        <ProductNavigationMainLink
          product={product}
          selectedCondition={selectedCondition}
        />
      ),
    },
    {
      id: '#properties',
      title: <ProductNavigationPropertiesLink product={product} />,
    },
    {
      id: '#reviews',
      title: <ProductNavigationReviewsLink product={product} />,
    },
    {
      id: '#statistics',
      title: <ProductNavigationHistoryLink product={product} />,
    },
  ];
};
